export const parseColumnsToFetchKeys = (
  keys?: string[],
  format?: 'xlsx' | 'pdf'
) => {
  if (!keys) return undefined

  const filteredKeys =
    format === 'xlsx' ? keys.filter(item => item !== 'id') : keys

  return filteredKeys as []
}
